




import { Component } from 'vue-property-decorator'

// mixins
import NotifyMixin from '@/mixins/NotifyMixin'
// store
import SystemModule from '@/store/modules/system'

@Component
export default class EmailReminder extends NotifyMixin {
  private get token() {
    return this.$route.params.token
  }

  private mounted() {
    SystemModule.emailReminderUnsubscribe(this.token)
      .then(() => {
        this.$router.replace({ name: 'email-reminder.unsubscribe', params: { token: this.token } })
      })
      .catch(() => {
        this.notifyError('Во время отписки произошла ошибка, повторите попытку позднее.')
        this.$router.replace({ name: 'auth.login' })
      })
  }
}
